import NextHead from "next/head";
import type { AppProps } from "next/app";
import { useEffect } from "react";
import { PageProps } from "frontend/types";

export default function App({ Component, pageProps }: AppProps<PageProps>) {
  useEffect(() => {
    const user = (pageProps as PageProps)?.session?.user;
    if (!user?.loggedIn || typeof document === "undefined") return;

    const value = `hbs.edu ${user.roles.join(" ")}`;
    const cookie = `HBSAnalytics=${encodeURIComponent(value)}; Path=/; Max-Age=1209600;`; // 2 weeks expiration
    document.cookie = cookie;
  }, [pageProps?.session?.user]);

  const alternateLinks = pageProps.currentPage?.alternateLinks || [];
  return (
    <>
      <NextHead>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" type="image/ico" href="/static-assets/favicon.ico" />

        {Object.values(alternateLinks).map((link) => {
          const parsedUrl = new URL(link.href);
          if (parsedUrl.hostname === "exed.hbs.edu") {
            parsedUrl.hostname = "www.exed.hbs.edu";
          }
          const url = parsedUrl.toString();

          return (
            <link
              key={link.hrefLang}
              rel="alternate"
              hrefLang={link.hrefLang}
              href={url}
            />
          );
        })}
      </NextHead>

      <Component {...pageProps} />
    </>
  );
}
